import { ResourceSelectedAction, ResourcesSelectedAction, SelectorActionCreator } from './model'
import fetchActionCreatorsFor from '../fetch/actionCreatorsFor'
import selectorBasicActionsFor from './basicActionsFor'

function selectorActionCreatorsFor<T>(resourceName: string, prefix?: string, origin?: string): SelectorActionCreator<T> {
  if (resourceName === null) throw new Error('fetchActionCreatorsFor: Expected resourceName')

  const selectorActionTypes = selectorBasicActionsFor(resourceName, prefix)

  return {
    ...fetchActionCreatorsFor<T[]>(resourceName, prefix, origin),
    resourceSelected(resource?: T): ResourceSelectedAction<T> {
      return {
        type: selectorActionTypes.resourceSelected,
        payload: { selected: resource },
        origin: origin
      }
    },
    resourcesSelected(resources?: T[]): ResourcesSelectedAction<T> {
      return {
        type: selectorActionTypes.resourcesSelected,
        payload: { resources: resources },
        origin: origin
      }
    }
  }
}

export default selectorActionCreatorsFor
